import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';

import FormField from 'components/FormField';
import {TextField} from 'components/Fields';

import ErrorBlock from 'components/ErrorBlock';
import {changeCleaningStatus} from 'ducks/allocations';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {locationRef, roomId, cleaningStatus} = props;
  const extraActions = props.getExtraActions();

  dispatch(
    changeCleaningStatus(
      {
        cleaningStatus,
        outOfServiceReason: values.outOfServiceReason,
        roomId,
        locationRef
      },
      extraActions
    )
  );
};

class AddOutOfServiceReasonForm extends React.Component<any> {
  render() {
    const {handleSubmit, error} = this.props;

    return (
      <div className="AddOutOfServiceReasonForm">
        <form onSubmit={handleSubmit}>
          {error && <ErrorBlock>{error}</ErrorBlock>}
          <FormField>
            <div className="AddOutOfServiceReasonForm__label">
              Please enter an out of service reason.
            </div>
            <Field
              name="outOfServiceReason"
              component={TextField}
              placeholder="Enter your reason..."
            />
          </FormField>
        </form>
      </div>
    );
  }
}

export default connect()(
  reduxForm({
    form: 'addOutOfServiceReason',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(AddOutOfServiceReasonForm)
) as React.ComponentType<any>;
